var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 335.2 353.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 20px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M321.6,96.3c0-10.2-4.1-20-11.3-27.2l-35.2-35.2c-7.2-7.2-17-11.3-27.2-11.3H52.1c-21.3,0-38.5,17.2-38.5,38.5v231c0,21.3,17.2,38.5,38.5,38.5h231c21.3,0,38.5-17.2,38.5-38.5V96.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.1,22.6v77h-115.5V22.6M90.6,330.6v-154h154v154"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveWhite);
export default __webpack_public_path__ + "static/media/Save_White.5268bfbcfe8164567b929634591332b1.svg";
export { ForwardRef as ReactComponent };